// extracted by mini-css-extract-plugin
export default {"tooltip_wrapper":"tooltip_tooltip_wrapper__5ZfG5","tooltip_box":"tooltip_tooltip_box__AsVMv","tooltip_arrow":"tooltip_tooltip_arrow__cuHij"};